export function reportTime(report) {
  // The body fallback supports reports served by the previous API during rollout.
  return report.updatedAt || report.createdAt || report.body?.match(/Oluşturulma: (\d{4}-\d{2}-\d{2}T\S+)/)?.[1] || report.date || '';
}
export function orderedReports(reports = []) {
  return [...reports].sort((a, b) => (Date.parse(reportTime(b)) || 0) - (Date.parse(reportTime(a)) || 0));
}
export function reportDateLabel(report) {
  const value = reportTime(report);
  if (!value || !Number.isFinite(Date.parse(value))) return 'Tarih kaydı yok';
  const hasTime = value.includes('T');
  const date = new Intl.DateTimeFormat('tr-TR', {
    timeZone: 'Europe/London', day: '2-digit', month: 'short', year: 'numeric',
    ...(hasTime ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } : {})
  }).format(new Date(value));
  return `${report.updatedAt ? 'Güncellendi: ' : ''}${date}${hasTime ? '' : ' · Saat kaydı yok'}`;
}
